<template>
  <div>
    <el-card shadow="always">
      <el-page-header
        v-if="id === ''"
        @back="back"
        title
        :content="$t('adicionar-nova-ausencia-programada')"
      ></el-page-header>
      <el-page-header
        v-if="id !== ''"
        @back="back"
        title
        :content="$t('atualizar-ausencia-programada')"
      ></el-page-header>
    </el-card>
    <br />
    <el-card>
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-position="top"
      >
        <el-form-item :label="$t('codigo')" prop="code">
          <el-col :xs="15" :sm="10" :md="10" :lg="5" :xl="5">
            <el-input
              ref="code"
              :disabled="id !== ''"
              v-model="ruleForm.code"
              maxlength="30"
            ></el-input>
          </el-col>
        </el-form-item>
        <el-form-item :label="$t('motivo')" prop="name">
          <el-input
            maxlength="255"
            ref="name"
            v-model="ruleForm.name"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('acao')" prop="action">
          <el-select
            v-model="ruleForm.action"
            placeholder="Selecione  uma opção"
          >
            <el-option key="2" label="Atestado" value="2"></el-option>
            <el-option key="3" label="Férias" value="3"></el-option>
            <el-option key="1" label="Ignorar Agenda" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('motorista')" prop="courier">
          <CouriersList
            v-model="ruleForm.courier"
            :current="ruleForm.courier"
          />
        </el-form-item>
        <el-form-item :label="$t('periodo')" prop="range">
          <el-date-picker
            v-model="ruleForm.range"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="à"
            format="dd/MM/yyyy"
            start-placeholder="Inicio"
            end-placeholder="Fim"
          ></el-date-picker>
        </el-form-item>
        <div class="bottom clearfix">
          <el-form-item>
            <el-button
              type="warning"
              v-if="id === ''"
              autofocus
              @click="submitForm('ruleForm')"
              >{{ $t("adicionar") }}</el-button
            >
            <el-button
              type="warning"
              v-if="id !== ''"
              autofocus
              @click="editForm('ruleForm')"
              >{{ $t("atualizar") }}</el-button
            >
            <el-button type="danger" @click="back()">{{
              $t("voltar")
            }}</el-button>
          </el-form-item>
        </div>
      </el-form>
    </el-card>
  </div>
</template> 
<script>
import { ScheduleAwayService } from "@/services/customers/schedule.away.services";
import { i18n } from "@/plugin/i18n";
import CouriersList from "@/xpost/views/umov/couriers/CouriersList";
import { UserService } from "@/services/users/user.services";

export default {
  name: "ScheduleAwayAdd",
  components: {
    CouriersList,
  },
  data() {
    return {
      id: "",
      user: {
        type: "2",
      },
      ruleForm: {
        name: "",
        code: "",
        courier: "",
        action: "1",
        range: [],
      },
      rules: {
        name: [
          {
            required: true,
            message: i18n.tc("nome-obrigatorio"),
            trigger: "blur",
          },
        ],
        code: [
          {
            required: true,
            message: i18n.tc("codigo-obrigatorio"),
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    back() {
      var vm = this;
      vm.$router.push("/cadastro/ausencia").catch(() => {});
    },
    get() {
      const vm = this;
      const loading = vm.$loading({
        lock: true,
        text: i18n.tc("carregando"),
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      ScheduleAwayService.get(vm.id)
        .then((response) => {
          vm.ruleForm.name = response.name;
          vm.ruleForm.code = response.code;
          vm.ruleForm.action = response.action;
          vm.ruleForm.range = [response.startedAt, response.finishedAt];
          vm.ruleForm.courier = response.courier ? response.courier.id : "";
        })
        .catch((error) => {
          vm.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    submitForm(formName) {
      const vm = this;
      vm.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = vm.$loading({
            lock: true,
            text: i18n.tc("carregando"),
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          ScheduleAwayService.add(vm.ruleForm)
            .then((response) => {
              this.$message({
                type: "success",
                message: i18n.tc("ausencia-programada-adicionado-sucesso"),
              });
              this.$refs[formName].resetFields();
              vm.$router.push({ name: "schedule.away" });
            })
            .catch((error) => {
              this.$message({
                type: "error",
                message: error,
              });
            })
            .finally(() => loading.close());
        } else {
          return false;
        }
      });
    },
    editForm(formName) {
      const vm = this;
      vm.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = vm.$loading({
            lock: true,
            text: i18n.tc("carregando"),
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          ScheduleAwayService.update(vm.id, vm.ruleForm)
            .then(() => {
              this.$message({
                type: "success",
                message: i18n.tc("ausencia-programada-atualizado-sucesso"),
              });
              vm.$router.push({ name: "schedule.away" });
            })
            .catch((error) => {
              this.$message({
                type: "error",
                message: error,
              });
            })
            .finally(() => loading.close());
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
  mounted() {
    const vm = this;
    UserService.me()
      .then((response) => {
        vm.user.type = response.type;
        if (vm.$route.params.id) {
          vm.id = vm.$route.params.id;
          vm.get();
        } else {
          vm.$refs.code.$el.children[0].focus();
        }
      })
      .catch((error) => {
        vm.$message({
          type: "error",
          message: error,
        });
      });
  },
};
</script>
<style scoped>
.el-page-header__left {
  display: flex !important;
}
form {
  margin-top: 20px;
}
@media screen and (min-width: 458px) {
  .col-form-label {
    text-align: right;
  }
}
</style>
